<template>
  <div class="group-weighing-summary">
    <div class="group-weighing-summary__grid">
      <div class="group-weighing-summary__item">
        <span class="group-weighing-summary__label">{{ summary.weightLabel }}</span>
        <span
          class="group-weighing-summary__value"
          :class="summary.isBelowMinimum ? 'group-weighing-summary__value--below' : 'group-weighing-summary__value--ok'"
        >{{ summary.weightText }}</span>
        <span v-if="clockTime" class="group-weighing-summary__time">{{ texts.WEIGHED_AT_PREFIX }} {{ clockTime }}</span>
      </div>
      <div class="group-weighing-summary__item">
        <span class="group-weighing-summary__label">{{ texts.MINIMUM_COOKED_LABEL }}</span>
        <span class="group-weighing-summary__value">{{ summary.minimumText }}</span>
      </div>
    </div>
    <p v-if="summary.yieldText" class="group-weighing-summary__yield">{{ summary.yieldText }}</p>
  </div>
</template>

<script>
import { TEXTS } from '../cookedWeightsConstants'
import { formatClockTime } from '../weighingSummary'

export default {
  name: 'GroupWeighingSummary',
  props: {
    summary: {
      type: Object,
      required: true
    }
  },
  computed: {
    texts () {
      return TEXTS
    },
    clockTime () {
      return formatClockTime(this.summary.weighedAt)
    }
  }
}
</script>

<style scoped>
.group-weighing-summary__grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px 16px;
  align-items: start;
}

.group-weighing-summary__item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.group-weighing-summary__label {
  font-size: var(--font-small);
  color: var(--text-body);
}

.group-weighing-summary__value {
  font-size: var(--font-large);
  font-weight: 700;
  line-height: 1.2;
  color: var(--text-strong);
  font-variant-numeric: tabular-nums;
}

.group-weighing-summary__value.group-weighing-summary__value--ok {
  color: var(--brand-green-text);
}

.group-weighing-summary__value.group-weighing-summary__value--below {
  color: var(--danger-text);
}

.group-weighing-summary__time {
  font-size: var(--font-small);
  color: var(--text-muted);
}

.group-weighing-summary__yield {
  margin: 10px 0 0;
  font-size: var(--font-small);
  color: var(--text-muted);
}

@media (max-width: 576px) {
  .group-weighing-summary__grid {
    grid-template-columns: 1fr;
  }
}
</style>
